module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.baseline) ? _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.baseline.name))])]), _vm._v(" "), _c('delete-baseline-modal', {
    attrs: {
      "baseline": _vm.baseline,
      "modalId": "delete-baseline-modal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-view-buttons"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-baseline-modal",
      modifiers: {
        "delete-baseline-modal": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n        Delete\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm baseline-detail-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("ID:")]), _vm._v(" "), _c('td', [_vm._v("B" + _vm._s(_vm.baseline.baseline_id))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Created:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getHumanDate(_vm.baseline.created_at + 'Z')))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Reporter:")]), _vm._v(" "), (_vm.reporter) ? _c('td', [_vm._v(_vm._s(_vm.reporter.displayName))]) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.baseline.description) ? _c('b-form-textarea', {
    attrs: {
      "plaintext": "",
      "no-resize": "",
      "max-rows": 6,
      "value": _vm.baseline.description
    }
  }) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("No description")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Requirements")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.baseline.requirement_revisions.length > 0) ? _c('table', {
    staticClass: "table table-sm baseline-detail-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.baseline.requirement_revisions), function(requirement_revision) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(requirement_revision.prefix) + _vm._s(requirement_revision.display_id ? requirement_revision.display_id : requirement_revision.requirement_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement_revision.name))])])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("No requirements in baseline")])])])])], 1) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12812aaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaselineDetail.vue
// module id = 998
// module chunks = 1